if (typeof customElements.get('nav-tiles-element') === 'undefined') {
  class NavTilesElement extends HTMLElement {
    static SELECTORS = {
      tile: '[data-nav-tile]',
      classLoading: 'is-loading',
      collectionSection: '[data-section-type="collection"]',
      navTiles: '[data-section-type="nav-tiles"]',
      collectionSectionHero: '[data-section-type="hero"]'
    };

    /** @type {Map<string, { collectionInner: string | null; navTilesInner: string | null; collectionSectionHeroInner: string | null }>} */
    static _fetchCache = new Map();

    /**
     * Tear down theme section JS (Collection, FiltersForm, etc.) and run onLoad again
     * after innerHTML or other replacement on the collection section root.
     */
    static reinitCollectionSection(sectionRoot) {

      const api = window.Shopify?.theme?.sections;
      if (!api?.unload || !api?.load || !sectionRoot?.getAttribute?.('data-section-id')) {
        return;
      }
      api.unload(sectionRoot);
      api.load('collection', sectionRoot);
    }

    static replaceSectionInnerHTML(element, innerHTML, onReplace) {
      if (element == null || innerHTML == null) return;

      element.innerHTML = innerHTML;
      if (typeof onReplace === 'function') {
        onReplace();
      }
    }

    constructor() {
      super();
      this._handleClick = this._handleClick.bind(this);
      this._handlePopState = this._handlePopState.bind(this);
    }

    connectedCallback() {
      this.addEventListener('click', this._handleClick);
      window.addEventListener('popstate', this._handlePopState);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._handleClick);
      window.removeEventListener('popstate', this._handlePopState);
    }

    async _handlePopState(event) {
      const url =
        (event.state && typeof event.state.url === 'string' && event.state.url) ||
        window.location.href;
      await this._fetchAndReplace(url);
    }

    async _handleClick(e) {
      const tile = e.target.closest(NavTilesElement.SELECTORS.tile);

      if (!tile) return;

      e.preventDefault();
      const url = tile.href;
      if (!url) return;


      tile.classList.add(NavTilesElement.SELECTORS.classLoading);
      await this._fetchAndReplace(url);

      tile.classList.remove(NavTilesElement.SELECTORS.classLoading);

      history.pushState({ navTiles: false, url }, '', url);
    }

    async _fetchAndReplace(url) {
      const currentCollection = document.querySelector(NavTilesElement.SELECTORS.collectionSection);
      const currentNavTiles = document.querySelector(NavTilesElement.SELECTORS.navTiles);
      const currentCollectionSectionHero = document.querySelector(NavTilesElement.SELECTORS.collectionSectionHero);

      if (!currentCollection || !currentNavTiles) return;

      try {
        let collectionInner = null;
        let navTilesInner = null;
        let collectionSectionHeroInner = null;


        if (NavTilesElement._fetchCache.has(url)) {
          const cached = NavTilesElement._fetchCache.get(url);
          collectionInner = cached.collectionInner;
          navTilesInner = cached.navTilesInner;
          collectionSectionHeroInner = cached.collectionSectionHeroInner;
        } else {
          const response = await fetch(url);
          const html = await response.text();
          const doc = new DOMParser().parseFromString(html, 'text/html');

          const newCollection = doc.querySelector(NavTilesElement.SELECTORS.collectionSection);
          const newNavTiles = doc.querySelector(NavTilesElement.SELECTORS.navTiles);
          const newCollectionHero = doc.querySelector(NavTilesElement.SELECTORS.collectionSectionHero);


          collectionInner = newCollection ? newCollection.innerHTML : null;
          navTilesInner = newNavTiles ? newNavTiles.innerHTML : null;
          collectionSectionHeroInner = newCollectionHero ? newCollectionHero.innerHTML : null;
          NavTilesElement._fetchCache.set(url, { collectionInner, navTilesInner, collectionSectionHeroInner });
        }

        NavTilesElement.replaceSectionInnerHTML(currentCollection, collectionInner, () => NavTilesElement.reinitCollectionSection(currentCollection));
        NavTilesElement.replaceSectionInnerHTML(currentNavTiles, navTilesInner);
        NavTilesElement.replaceSectionInnerHTML(currentCollectionSectionHero, collectionSectionHeroInner);

      } catch (err) {
        console.error(`Failed to fetch ${url}:`, err);
      }
    }
  }

  customElements.define('nav-tiles-element', NavTilesElement);
}
